import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

class CustomDropZone extends React.Component {
  render() {
    let {
      fileList,
      removeFile,
      updateFileList,
      name,
      headingMap,
      uploadMsg,
      extraTest,
      showSupportedFormats,
    } = this.props;
    return (
      <div className="customDropZone">
        <div className="d-flex flex-column">
          <div className="d-flex" style={{ minHeight: '52px' }}>
            <h5 className={`font-family-montserrat-semi-bold` + (name === 'second' ? "" : "")}>
              {headingMap[name]}
            </h5>
            <h5 style={{ marginLeft: "5px" }}>{extraTest ? extraTest : ""}</h5>
          </div>
        </div>
        <DropZone
          listLen={Object.keys(fileList[name]).length}
          updateFileList={updateFileList}
          name={name}
          showSupportedFormats={showSupportedFormats}
        />
        <ul className="list-group list-group-flush">
          {Object.keys(fileList[name]).map((val) => (
            <li
              className="list-group-item d-flex justify-content-between"
              key={val}
            >
              <span>{val}</span>
              {fileList[name][val] !== "#empty" && (
                <span
                  className="fw-bold"
                  onClick={() => removeFile(name, val)}
                >
                  {"X"}
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

const DropZone = (props) => {
  let { updateFileList, listLen, name, showSupportedFormats } = props;
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      updateFileList(name, file);
    });
  }, listLen);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div {...getRootProps({ className: `dropzone` })}>
      <input {...getInputProps()} />
      <span>{"📂"}</span>
      <div className="dropZoneText">
        Drag &amp; drop files or Browse
      </div>
      {(
        <div>
          <p className="font-family-montserrat" style={{ fontSize: "12px", color: "grey", marginBottom: "0px" }}>
            Supported Formats : Excel(.xlsx, .xls) , Max File Size : 10MB
          </p>
          <p>
            <p className="font-family-montserrat" style={{ fontSize: "12px", color: "grey", marginBottom: "0px" }}>
              Upload one or more Payroll file at once
            </p>
          </p>
        </div>
      )}
    </div>
  );
};

export default CustomDropZone;
